import { render, staticRenderFns } from "./companyCard.vue?vue&type=template&id=5010412e&scoped=true&lang=pug&"
import script from "./companyCard.vue?vue&type=script&lang=js&"
export * from "./companyCard.vue?vue&type=script&lang=js&"
import style0 from "./companyCard.vue?vue&type=style&index=0&id=5010412e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5010412e",
  null
  
)

export default component.exports